import React from 'react';
import { Dialog, DialogButtonRow } from './Dialog';
import { Container } from './Container';
import { Body1, Body5 } from '../text';
import { FlatButton, TransparentFlatButton } from '../buttons';

// A reusable confirm dialog built on Modal: a title, a body, and a confirm/cancel pair with
// explicit verbs (e.g. "Delete draft") so severity is conveyed by copy rather than a generic
// Yes/No. Parent controls mounting: {open && <ConfirmModal … />}.
//
// NOTE: @ui buttons are visual-only-disabled (a `disabled` button still fires onClick), so the
// handlers are guarded on `busy` here rather than relying on the disabled attribute.
export const ConfirmModal = ({
  title,
  body,
  confirmLabel,
  cancelLabel = 'Cancel',
  busy = false,
  maxWidth,
  onConfirm,
  onCancel,
}) => {
  const confirm = () => {
    if (busy) return;
    onConfirm();
  };
  const cancel = () => {
    if (busy) return;
    onCancel();
  };

  return (
    <Dialog label={title} onDismiss={cancel} maxWidth={maxWidth ? `${maxWidth}px` : undefined}>
      <Body1 bold>{title}</Body1>
      <Container top={12}>
        <Body5>{body}</Body5>
      </Container>
      <Container top={24}>
        <DialogButtonRow>
          <TransparentFlatButton onClick={cancel} disabled={busy}>
            {cancelLabel}
          </TransparentFlatButton>
          <FlatButton onClick={confirm} disabled={busy}>
            {busy ? 'Working…' : confirmLabel}
          </FlatButton>
        </DialogButtonRow>
      </Container>
    </Dialog>
  );
};
